module.exports = __webpack_public_path__ + "img/upcoming-fixtures-1.12f03140.svg";